import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import NewStoneLogo from "./NewStoneLogo.webp";
import "./ReferralPage.css";

const ReferralPage = () => {
  const { code } = useParams();
  const [status, setStatus] = useState("trying");

  useEffect(() => {
    if (!code) return;

    localStorage.setItem("stonecircle_referral_code", code);
    trackReferralClick(code);

    // Try to open the app
    const appUrl = `stonecircle://referral/${code}`;
    window.location.href = appUrl;

    // Faster redirect - only 1.5 seconds
    const timer = setTimeout(() => {
      setStatus("redirecting");
      const storeUrl = getStoreUrl(code); // 🔹 Pass referral code to store URL

      // Brief delay to show redirecting message
      setTimeout(() => {
        window.location.href = storeUrl;
      }, 300);
    }, 1500);

    return () => clearTimeout(timer);
  }, [code]);

  const trackReferralClick = async (referralCode) => {
    try {
      await fetch("/api/track-referral-click", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          referralCode,
          userAgent: navigator.userAgent,
          timestamp: new Date().toISOString(),
        }),
      });
    } catch (error) {
      console.error("Failed to track referral click:", error);
    }
  };

  // 🔹 UPDATED: Include referral code in store URLs
  const getStoreUrl = (referralCode) => {
    const isAndroid = /Android/i.test(navigator.userAgent);

    if (isAndroid) {
      // 🔹 Add referrer parameter for Google Play Install Referrer API
      const referrerData = encodeURIComponent(
        `referral_code=${referralCode}&utm_source=stonecircle&utm_campaign=referral`
      );
      return `https://play.google.com/store/apps/details?id=com.stonecircle.community&referrer=${referrerData}`;
    } else {
      // 🔹 For iOS, we'll use a different approach (server-side tracking)
      return `https://apps.apple.com/ng/app/stonecircle/id6742403322`;
    }
  };

  return (
    <>
      <div className="page-container">
        <div className="container">
          <div className="logo">
            <img
              src={NewStoneLogo || "/placeholder.svg"}
              alt="Stone Circle Logo"
              className="logo-image"
              style={{ width: "100px", height: "100px" }}
            />
          </div>
          <h1>Join Stone Circle</h1>
          <p className="tagline">Peace of mind</p>

          <div className="referral-code">
            <strong>🎉 You've been invited!</strong>
            <br />
            Referral code: <span className="code-highlight">{code || "WELCOME"}</span>
          </div>

          <div className={`status ${status}`}>
            <div className="spinner"></div>
            {status === "trying" ? "Opening Stone Circle app..." : "Redirecting to store..."}
          </div>
        </div>
      </div>
    </>
  );
};

export default ReferralPage;
